import { createFileRoute } from "@tanstack/react-router";

import { EnterpriseApplicationDetailPage } from "@/features/enterprise/application-detail-page";
import { applicationDetailQueryOptions } from "@/features/applications/queries";
import { applicantNameCrumb } from "@/lib/crumb-resolvers";

// ロールガードは親 layout (`enterprise/route.tsx`) が ENTERPRISE 限定。
export const Route = createFileRoute(
  "/_authenticated/enterprise/$id/applications/$appId",
)({
  staticData: { crumb: applicantNameCrumb() },
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      applicationDetailQueryOptions(params.appId),
    );
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { appId } = Route.useParams();
  return <EnterpriseApplicationDetailPage appId={appId} />;
}
